<template>
    <div>
        <modal :show.sync="addProduct" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Otro gastos</h6>
                <div class="form-group">
                    <label>Detalle *</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="detalle"
                                placeholder="detalle"
                                autocomplete="off"
                                v-validate="modelValidations.expenseName"
                                :error="getError('detalle')"
                                v-model="expenseName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Cantidad</label>
                    <fg-input   tabindex="2"
                                type="number"
                                name="cantidad"
                                placeholder="cantidad"
                                autocomplete="off"
                                v-validate="modelValidations.expenseQty"
                                :error="getError('cantidad')"
                                v-model="expenseQty">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Valor unidad</label>
                    <vue-numeric  :max=9999999 tabindex="8" currency="$" autocomplete="off" name="valor unidad" v-validate="modelValidations.expenseValue" :error="getError('valor unidad')" separator="." class="form-control" v-model="expenseValue"></vue-numeric>
                    <span v-show="errors.has('valor unidad')" class="text-danger" style="font-size: 11px;">
                        {{ errors.first('valor unidad') }}
                    </span>
                </div>
                <div class="form-group">
                    <label>Total</label>
                    <vue-numeric  disabled :max=999999999 tabindex="8" currency="$" autocomplete="off" name="total" v-validate="modelValidations.expenseTotal" :error="getError('total')" separator="." class="form-control" v-model="expenseTotalComputed"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Periodicidad</label>
                    <fg-input   tabindex="1"
                                name="periodicidad"
                                v-validate="modelValidations.expensePeriodicity"
                                :error="getError('periodicidad')"
                                v-model="expensePeriodicity">
                            <el-select
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="expensePeriodicity">
                            <el-option
                                    class="select-warning"
                                    value="Mensual"
                                    label="Mensual">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Bimensual"
                                    label="Bimensual">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Trimestral"
                                    label="Trimestral">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Semestral"
                                    label="Semestral">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Anual"
                                    label="Anual">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Seleccionar mes"
                                    label="Seleccionar mes">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div v-if="expensePeriodicity == 'Seleccionar mes'" class="form-group">
                    <label>Seleccione mes (Periodicidad)</label>
                    <el-date-picker
                        v-model="expensePeriodicityDate"
                        type="month"
                        placeholder="Seleccione mes (periodicidad)">
                    </el-date-picker>
                </div>
                <div class="form-group">
                    <label>Mes inicio periodicidad</label>
                    <el-date-picker
                        v-model="expenseDate"
                        type="month"
                        placeholder="Seleccione mes inicio periodicidad">
                    </el-date-picker>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelAddProduct()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="addProductToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <modal :show.sync="editProduct" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Otros gastos</h6>
            <div class="form-group">
                    <label>Detalle *</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="detalle"
                                placeholder="detalle"
                                autocomplete="off"
                                v-validate="modelValidations.expenseName"
                                :error="getError('detalle')"
                                v-model="expenseName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Cantidad</label>
                    <fg-input   tabindex="2"
                                type="number"
                                name="cantidad"
                                placeholder="cantidad"
                                autocomplete="off"
                                v-validate="modelValidations.expenseQty"
                                :error="getError('cantidad')"
                                v-model="expenseQty">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Valor unidad</label>
                    <vue-numeric  :max=9999999 tabindex="8" currency="$" autocomplete="off" name="valor unidad" v-validate="modelValidations.expenseValue" :error="getError('valor unidad')" separator="." class="form-control" v-model="expenseValue"></vue-numeric>
                    <span v-show="errors.has('valor unidad')" class="text-danger" style="font-size: 11px;">
                        {{ errors.first('valor unidad') }}
                    </span>
                </div>
                <div class="form-group">
                    <label>Total</label>
                    <vue-numeric  disabled :max=999999999 tabindex="8" currency="$" autocomplete="off" name="total" v-validate="modelValidations.expenseTotal" :error="getError('total')" separator="." class="form-control" v-model="expenseTotalComputed"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Periodicidad</label>
                    <fg-input   tabindex="1"
                                name="periodicidad"
                                v-validate="modelValidations.expensePeriodicity"
                                :error="getError('periodicidad')"
                                v-model="expensePeriodicity">
                            <el-select
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="expensePeriodicity">
                            <el-option
                                    class="select-warning"
                                    value="Mensual"
                                    label="Mensual">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Bimensual"
                                    label="Bimensual">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Trimestral"
                                    label="Trimestral">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Semestral"
                                    label="Semestral">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Anual"
                                    label="Anual">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Seleccionar mes"
                                    label="Seleccionar mes">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div v-if="expensePeriodicity == 'Seleccionar mes'" class="form-group">
                    <label>Seleccione mes (Periodicidad)</label>
                    <el-date-picker
                        v-model="expensePeriodicityDate"
                        type="month"
                        placeholder="Seleccione mes (periodicidad)">
                    </el-date-picker>
                </div>
                <div class="form-group">
                    <label>Mes inicio periodicidad</label>
                    <el-date-picker
                        v-model="expenseDate"
                        type="month"
                        placeholder="Seleccione mes inicio periodicidad">
                    </el-date-picker>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelEditProduct()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="editProductToList()">Editar</p-button>
                </div>
            </template>
        </modal>
        <div class="col-md-12 mb-2">
                <h4 class="title center-title">Hoja de trabajo</h4>
        </div>
        <!-- Inventory -->
        <card  class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">OTROS GASTOS</h6>
            </div>
            <div class="card-body">
                <el-table v-if="products.length" :data="products"  ref="productsTable"  highlight-current-row @current-change="handleCurrentChange">
                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <p>Detalle:{{ props.row.expenseName }}</p>
                            <p>Cantidad: {{ props.row.expenseQty }}</p>
                            <p>Valor unidad: {{ setFormat(props.row.expenseValue) }}</p>
                            <p>Total: {{ setFormat(props.row.expenseTotal) }}</p>
                            <p>Periodicidad: {{ props.row.expensePeriodicity }}</p>
                            <p>Mes seleccionado (Periodicidad): {{ formatDate(props.row.expensePeriodicityDate) }}</p>
                            <p>Mes inicio periodicidad: {{ formatDate(props.row.expenseDate) }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column label="Detalle" property="expenseName"></el-table-column>
                    <el-table-column label="Total">
                        <template slot-scope="scope">
                            <span >{{ setFormat(scope.row.expenseTotal )}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                
                <div>
                    <p-button 
                        v-if="products.length < 8"
                        @click="addProductMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-plus"></i>Agregar otros gastos
                    </p-button>
                    <br>
                    <p-button v-if="currentRow"
                        @click="editProductMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-pencil"></i>Editar otros gastos
                    </p-button>
                    <br>
                    <p-button v-if="currentRow"
                        @click="removeProductMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-minus"></i>Quitar otros gastos
                    </p-button>
                </div>
            </div>
            <div class="card-footer">
                <div v-if="totalInventory != 0" class="alert alert-warning mt-2">
                    <span>Valor total Otros gastos: {{ setFormat(totalInventory)}}</span>
                </div>
            </div>
        </card>
        <div class="text-right">
            <p-button @click="saveData()" type="warning">Siguiente</p-button>
            <p-button @click="toMenu()" type="default" class="pull-left mb-3">Atrás</p-button>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue'
    import swal from 'sweetalert2'
    import { Card, Collapse, CollapseItem, Modal } from 'src/components/UIComponents'
    import PSwitch from 'src/components/UIComponents/Switch.vue'
    import VueNumeric from 'vue-numeric'
    import formatMoney from 'accounting-js/lib/formatMoney.js'
    import {Select, Option, Table, TableColumn, DatePicker} from 'element-ui'
    import Expenses from 'src/util/Others/OperatingExpenses'
    import Taxes from 'src/util/Services/Taxes'
    import moment from 'moment'
    Vue.use(Select)
    Vue.use(Option)
    Vue.use(Table)
    Vue.use(TableColumn)
    export default {
        components: {
            Card,
            PSwitch,
            VueNumeric,
            Collapse,
            CollapseItem,
            Modal,
            [DatePicker.name]: DatePicker,
        },
        data() {
        return {
            cashFlowData: null,
            form: {
                average_selection: '',
            },
            operatingSwitches: {
                expenses: false,
                inventory: false,
            },
            microcredit: false,
            consumer: false,
            pyme: false,
            expenses : [],
            actualExpenses: [],
            currentRow: null,
            addExpense: false,
            editExpense: false,
            addExpenseIndex: null,
            addProduct: false,
            editProduct: false,
            addProductIndex: null,
            monthlyNumber: '',
            expenseName: '',
            expenseQty: '',
            expenseValue: '',
            expenseTotal: '',
            expensePeriodicity: '',
            expensePeriodicityDate: '',
            expenseDate: '',
            referenceDescription: '',
            products: [
                
            ],
            costs: [],
            average: {
                good_sale: '',
                bad_sale: '',
                regular_sale: '',
                average_sales: '',
                monthly_average_sales: ''
            },
            modelValidations: {
                expenseName: {
                    required: true,
                    max: 50,
                    regex: /^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9 ]*$/
                },
                expenseQty: {
                    max: 7
                },
                expenseValue: {
                    required: false
                },
                expenseTotal: {
                    required: false
                },
                expensePeriodicity: {
                    required: false
                },
                expensePeriodicityDate: {
                    required: false
                },
                expenseDate: {
                    required: false
                }
            },
        }
        },
        watch: {
            expensePeriodicity: function(newVal) {
                if (newVal != 'Seleccionar mes') {
                    this.expensePeriodicityDate = '';
                }
            }
           
        },
        computed: {

            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             totalInventory() {
                var sum = 0;
                for (let i = 0;i<this.products.length;i++) {
                    sum = sum + (parseFloat(this.products[i].expenseTotal) || 0); 
                }
                return sum
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            expenseTotalComputed () {
                if(this.expenseValue != '' && this.expenseQty != '') {
                    this.expenseTotal = parseFloat(this.expenseValue) * parseFloat(this.expenseQty);
                    return this.expenseTotal;
                }
                else {
                    this.expenseTotal = 0;
                    return 0
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            verifyNext () {
                if (!this.operatingSwitches.expenses && !this.operatingSwitches.inventory) {
                    return true
                }
                else if(this.operatingSwitches.expenses && this.operatingSwitches.inventory &&  this.allExpensesMonthlyCostComputed != 0 && this.totalInventory != 0) {
                    return true
                }
                else if(this.operatingSwitches.expenses  &&  this.allExpensesMonthlyCostComputed ) {
                    if(!this.operatingSwitches.inventory) {
                        return true
                    }
                }
                else if(this.operatingSwitches.inventory  &&  this.totalInventory ) {
                    if(!this.operatingSwitches.expenses) {
                        return true
                    }
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productCostTotalComputed() {
                var total = this.productQuantity * this.productSaleUnity;
                this.productCostTotal = total;
                return total;
            },
            
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productMonthlyCostComputed() {
                var total = 0;
                if (this.monthlyNumber != '') {
                    var total = this.productQuantity * this.productCostUnity * this.monthlyNumber;
                    this.productMonthlyCost = total;
                }
                return total;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            allExpensesMonthlyCostComputed() {
                var sum = 0;
                for (let i=0;i<this.actualExpenses.length;i++) {
                    sum = sum + (this.actualExpenses[i].value);
                }
                return sum   
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            allCostsComputed() {
                return this.allExpensesMonthlyCostComputed
            }
        },
        methods: {
            initializeAnotherExpensesInMonths(expenseData, months) {
                console.log("📢 Inicializando otro gasto en cada mes...");

                let updatedMonths = JSON.parse(JSON.stringify(months));

                // 📌 Inicializar el total acumulado de otro gasto
                let totalizedAnotherExpenses = 0;

                updatedMonths.forEach(month => {
                    // 1️⃣ Inicializar el total de otro gasto en 0 para cada mes
                    month.anotherExpenses = 0;

                    console.log(`✅ ${month.name}: AnotherExpensesExpenses inicializado en 0.`);
                });

                console.log("✅ Mano de obra inicializada correctamente.");
                console.log("📌 Totalized AnotherExpenses inicializado en 0:", totalizedAnotherExpenses);

                return { updatedMonths, totalizedAnotherExpenses };
            },
            assignAnotherExpensesToMonths(expenseData, updatedMonths, totalizedAnotherExpenses) {
                console.log("📢 Asignando valores de otro gasto a los meses...");

                expenseData.forEach(expense => {
                    let startDate = new Date(expense.expenseDate);
                    let expenseTotal = parseInt(expense.expenseTotal);
                    let periodicity = expense.expensePeriodicity;
                    let selectedMonthDate = expense.expensePeriodicityDate ? new Date(expense.expensePeriodicityDate) : null;

                    console.log(`🛠️ Procesando otro gasto: ${expense.expenseName} | Periodicidad: ${periodicity} | Fecha Inicio: ${startDate.toDateString()}`);

                    // 📌 Si es "Seleccionar mes", asignamos SOLO en el mes especificado
                    if (periodicity === "Seleccionar mes" && selectedMonthDate) {
                        let selectedMonthName = this.getMonthName(selectedMonthDate.getMonth() + 1);
                        let selectedYear = selectedMonthDate.getFullYear().toString().slice(-2);
                        let selectedMonthKey = `${selectedMonthName}/${selectedYear}`;

                        let monthEntry = updatedMonths.find(m => m.name === selectedMonthKey);
                        if (monthEntry) {
                            console.log(`💰 Asignando ${expenseTotal} a ${selectedMonthKey} porque es "Seleccionar mes".`);
                            monthEntry.anotherExpenses += expenseTotal;
                            totalizedAnotherExpenses += expenseTotal;
                        } else {
                            console.log(`⚠️ No se encontró el mes ${selectedMonthKey} en los datos.`);
                        }

                        return; // ⬅️ Terminamos aquí, ya que no hay más meses en este caso
                    }

                    // 📌 Encontrar el primer mes válido si no es "Seleccionar mes"
                    let firstValidMonth = updatedMonths.find(month => {
                        let [monthName, year] = month.name.split("/");
                        let monthIndex = this.getMonthIndex(monthName);
                        let fullYear = parseInt("20" + year);

                        return new Date(fullYear, monthIndex - 1, 1) >= startDate;
                    });

                    if (!firstValidMonth) return;

                    let currentMonthName = firstValidMonth.name;

                    // 📌 Aplicar la periodicidad correctamente
                    while (currentMonthName) {
                        let monthEntry = updatedMonths.find(m => m.name === currentMonthName);
                        if (!monthEntry) break;

                        console.log(`💰 Sumando ${expenseTotal} a ${monthEntry.name}`);

                        // 🛠️ Sumar el valor al mes correspondiente
                        monthEntry.anotherExpenses += expenseTotal;

                        // 🛠️ Sumar al total global
                        totalizedAnotherExpenses += expenseTotal;

                        // 🔄 Buscar el siguiente mes según la periodicidad
                        let prevMonth = currentMonthName; // Debugging
                        currentMonthName = this.getNextMonth(currentMonthName, periodicity, updatedMonths);

                        console.log(`🔄 ${prevMonth} → ${currentMonthName} (Periodicidad: ${periodicity})`);
                    }
                });

                console.log("✅ Mano de obra asignada correctamente.");
                console.log("📌 Totalized AnotherExpenses Final:", totalizedAnotherExpenses);

                return { updatedMonths, totalizedAnotherExpenses };
            },
            getNextMonth(currentMonth, periodicity, validMonths) {
                let [month, year] = currentMonth.split("/");
                let monthIndex = this.getMonthIndex(month);
                let fullYear = parseInt("20" + year);

                let monthsToAdd = {
                    "Mensual": 1,
                    "Bimensual": 2,
                    "Trimestral": 3,
                    "Semestral": 6,
                    "Anual": 12,
                    "Seleccionar mes": 0  // No avanza si es un solo mes específico
                }[periodicity] || 1; 

                if (monthsToAdd === 0) return null; // No avanza si es un mes fijo

                // 📌 Incrementar el mes según la periodicidad
                monthIndex += monthsToAdd;

                // 📌 Si pasamos diciembre, incrementamos el año
                if (monthIndex > 12) {
                    monthIndex -= 12;
                    fullYear += 1;
                }

                // 📌 Convertir el índice del mes de vuelta a su nombre
                let nextMonthName = this.getMonthName(monthIndex);
                let nextMonth = `${nextMonthName}/${String(fullYear).slice(-2)}`;

                return validMonths.some(m => m.name === nextMonth) ? nextMonth : null;
            },
            getMonthIndex(monthName) {
                const months = {
                    "Enero": 1, "Febrero": 2, "Marzo": 3, "Abril": 4, "Mayo": 5, "Junio": 6,
                    "Julio": 7, "Agosto": 8, "Septiembre": 9, "Octubre": 10, "Noviembre": 11, "Diciembre": 12
                };
                return months[monthName] || -1; // Retorna -1 si el mes no es válido
            },
            getMonthName(monthIndex) {
                const months = [
                    "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
                    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
                ];
                return months[monthIndex - 1] || null; // Retorna null si el índice no es válido
            },
            toMenu () {
                this.$router.push('/asessments/menu');
            },
            formatDate(date) {
                if (!date) return '';
                const formattedDate = new Date(date).toLocaleDateString('es-ES', {
                year: 'numeric',
                month: '2-digit'
                });
                return formattedDate;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productValidator (product) {
                if (this.$store.state.isCustomer) {
                    if (product.name.toLowerCase() == 'consumo') {
                        this.consumer = true;
                        this.microcredit = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                        this.microcredit = true;
                        this.consumer = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'pequeña empresa') {
                        this.microcredit = false;
                        this.consumer = false;
                        this.pyme = true;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references;
                            
                        }
                    }
                    
                }
                else if(this.$store.state.isSpouse) {
                    if (product.name.toLowerCase() == 'consumo') {
                        this.consumer = true;
                        this.microcredit = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                        this.microcredit = true;
                        this.consumer = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'pequeña empresa') {
                        this.microcredit = false;
                        this.consumer = false;
                        this.pyme = true;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references;
                            
                        }
                    }
                    
                }
                if (this.$store.state.isGuarantor) {
                    if (product.name.toLowerCase() == 'consumo') {
                        this.consumer = true;
                        this.microcredit = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                        this.microcredit = true;
                        this.consumer = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'pequeña empresa') {
                        this.microcredit = false;
                        this.consumer = false;
                        this.pyme = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references;
                            
                        }
                    }
                    
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            handleCurrentChange(currentRow, oldCurrentRow) {
                this.currentRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editExpenseToList () {
                if (this.expenseName == '') {
                    this.showNotificationError('El campo nombre de gasto no puede estar vacío');
                }
                else {
                    var index = this.actualExpenses.indexOf(this.currentRow);
                    this.actualExpenses[index].name = this.expenseName;
                    this.actualExpenses[index].value = this.expenseValue;
                    this.resetExpense();
                    this.currentRow = null;
                    this.$refs.expensesTable.setCurrentRow();
                    this.editExpense = false;
                    this.showNotificationSuccess('Gasto editado correctamente');
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addExpenseMethod (row) {
                // this.addProductIndex = row;
                this.addExpense = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        this.products.push({
                            expenseName: this.expenseName,
                            expenseQty: parseFloat(this.expenseQty) || 0,
                            expenseValue: parseFloat(this.expenseValue) || 0,
                            expenseTotal: parseFloat(this.expenseTotal) || 0,
                            expensePeriodicity: this.expensePeriodicity,
                            expensePeriodicityDate: this.expensePeriodicityDate,
                            expenseDate: this.expenseDate
                        })
                        this.resetProduct();
                        this.addProduct = false;
                        this.errors.clear();
                        this.showNotificationSuccess('Otro gasto agregado correctamente');
                        }
                        else {
                            console.error('Error: Campos no diligenciados correctamente');
                            console.log('Errores de validación:', this.errors.items); // Muestra los errores específicos
                            this.errors.items.forEach(error => {
                                console.log(`Campo: ${error.field}, Mensaje: ${error.msg}`);
                            });
                            this.showNotificationError('Campos no diligenciados correctamente');
                        }
                })

            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetProduct () {
                this.expenseName = '';
                this.expenseQty = '';
                this.expenseValue = '';
                this.expenseTotal = '';
                this.expensePeriodicity = '';
                this.expensePeriodicityDate = '';
                this.expenseDate = '';
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editProductMethod () {
                this.expenseName =  this.currentRow.expenseName;
                this.expenseQty =  this.currentRow.expenseQty;
                this.expenseValue =  this.currentRow.expenseValue;
                this.expenseTotal =  this.currentRow.expenseTotal;
                this.expensePeriodicity =  this.currentRow.expensePeriodicity;
                this.expensePeriodicityDate = this.currentRow.expensePeriodicityDate;
                this.expenseDate =  this.currentRow.expenseDate;
                this.editProduct = true;  
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeProductMethod () {
                this.products.splice(this.products.indexOf(this.currentRow),1);
                this.currentRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editProductToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                            var index = this.products.indexOf(this.currentRow);
                            this.products[index].expenseName = this.expenseName;
                            this.products[index].expenseQty = parseFloat(this.expenseQty) || 0;
                            this.products[index].expenseValue = parseFloat(this.expenseValue) || 0;
                            this.products[index].expenseTotal = parseFloat(this.expenseTotal) || 0;
                            this.products[index].expensePeriodicity = this.expensePeriodicity;
                            this.products[index].expensePeriodicityDate = this.expensePeriodicityDate;
                            this.products[index].expenseDate = this.expenseDate;
                            this.resetProduct();
                            this.currentRow = null;
                            this.$refs.productsTable.setCurrentRow();
                            this.editProduct = false;
                            this.errors.clear();
                            this.showNotificationSuccess('Otro gasto editado correctamente');
                        }
                })
                
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductMethod (row) {
                this.addProductIndex = row;
                this.errors.clear();
                this.addProduct = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddProduct () {
                this.addProduct = false;
                this.errors.clear();
                this.resetItem();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditProduct () {
                this.editProduct = false;
                this.errors.clear();
                this.resetItem();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetItem () {
                this.itemName = '';
                this.itemPurchasePrice = '';
                this.itemSalePrice = '';
                this.itemPercent = '';
                this.productName= '';
                this.productQuantity= '';
                this.productCostUnity= '';
                this.productSaleUnity= '';
                this.productCostTotal= '';
                this.productMonthlyCost= '';
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationSuccess (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-check-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addExpenseToList () {
                if (this.expenseName == '') {
                    this.showNotificationError('El campo nombre de gasto no puede estar vacío');
                }
                else {
                    var id = this.actualExpenses.length + 1;
                    this.actualExpenses.push({
                        id: id,
                        name: this.expenseName,
                        value: this.expenseValue,
                        locked: false
                    })
                    this.resetExpense();
                    this.addExpense = false;
                    this.showNotificationSuccess('Gasto agregado correctamente');
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetExpense () {
                this.expenseName = '';
                this.expenseValue = '';   
                this.expenseLocked = false;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductMethod () {
                this.addProduct = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editExpenseMethod () {
                this.expenseName= this.currentRow.name;
                this.expenseValue= this.currentRow.value;
                this.expenseLocked = this.currentRow.locked;
                this.editExpense = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeExpenseMethod () {
                this.actualExpenses.splice(this.actualExpenses.indexOf(this.currentRow),1);
                this.currentRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddExpense () {
                this.addExpense = false;
                this.resetExpense();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditExpense () {
                this.editExpense = false;
                this.resetExpense();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            setFormat (value) {
                return formatMoney(value, { symbol: "$", precision: 0, thousand: ".", decimal: "," });
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toSalesCostsSelection () {
                this.$router.push('/asessments/new_asessment/customer/sales_costs_selection');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toOperatingExpenses () {
                this.$router.push('/asessments/new_asessment/customer/others/operating_expenses');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toRequestData () {
                this.$router.push('/asessments/new_asessment/customer/request_data');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             saveData () {
                if (this.products.length != 0) {
                    let { updatedMonths, totalizedAnotherExpenses } = this.initializeAnotherExpensesInMonths(this.products, this.cashFlowData.months);
                    ({ updatedMonths, totalizedAnotherExpenses } = this.assignAnotherExpensesToMonths(this.products, updatedMonths, totalizedAnotherExpenses));
                    const payload = {
                        products: this.products,
                        months: updatedMonths,
                        totalizedAnotherExpenses: totalizedAnotherExpenses
                    };
                    this.$store.dispatch('setAgroAnotherExpenses', payload).then(()=>{
                        var vm = this;
                        const routes = [
                            {
                                title: '¿Deseas agregar Obligaciones financieras o con proveedores a la actividad económica agropecuaria?',
                                text: 'Si aceptas, podrás agregar o editar la información de Obligaciones financieras o con proveedores a la actividad económica agropecuaria',
                                route: '/asessments/new_asessment/customer/agro/financial_obligations'
                            }
                        ];
                        let currentIndex = 0;
                        function askRoute() {
                            if (currentIndex < routes.length) {
                                const current = routes[currentIndex];
                                swal({
                                    title: current.title,
                                    text: current.text,
                                    type: 'info',
                                    showCancelButton: true,
                                    confirmButtonText: 'Si, aceptar',
                                    cancelButtonText: 'No, continuar',
                                    confirmButtonClass: 'btn btn-success btn-fill',
                                    cancelButtonClass: 'btn btn-danger btn-fill',
                                    buttonsStyling: false
                                }).then(() => {
                                    vm.$router.push(current.route); // Redirige a la ruta correspondiente
                                }, (dismiss) => {
                                    if (dismiss === 'cancel') {
                                        // currentIndex++; // Avanza al siguiente paso
                                        // askRoute(); // Llama recursivamente para mostrar la siguiente pregunta
                                        swal({
                                            title: '¿Deseas agregar información comercial a la unidad productiva Agro?',
                                            text: 'Tienda/Comercio de mercancía/Actividades de servicios/Actividades de producción',
                                            type: 'info',
                                            showCancelButton: true,
                                            confirmButtonText: 'Si, aceptar',
                                            cancelButtonText: 'No, continuar',
                                            confirmButtonClass: 'btn btn-success btn-fill',
                                            cancelButtonClass: 'btn btn-danger btn-fill',
                                            buttonsStyling: false
                                        }).then(() => {
                                            vm.$store.dispatch('newStudy', 'customer').then(()=>{
                                                vm.$router.push('/asessments/new_asessment/customer/request_data');
                                            });
                                        }, function (dismiss) {
                                            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                            if (dismiss == 'cancel') {
                                                vm.$router.push('/asessments/new_asessment/customer/others/additional_information');
                                            }
                                            else {
                                                swal({
                                                    title: 'Cancelado',
                                                    text: 'El analista no ha continuado',
                                                    type: 'error', 
                                                    confirmButtonClass: 'btn btn-info btn-fill',
                                                    buttonsStyling: false
                                                })
                                            }
                                        })
                                    } else {
                                        swal({
                                            title: 'Cancelado',
                                            text: 'El analista no ha continuado',
                                            type: 'error',
                                            confirmButtonClass: 'btn btn-info btn-fill',
                                            buttonsStyling: false
                                        });
                                    }
                                });
                            } else {
                                vm.$router.push('/asessments/menu');
                            }
                        }
                        // Llama la función para iniciar el flujo
                        askRoute(); 
                    });
                }
                else {
                    this.showNotificationError('Debe ingresar datos otros gastos');
                }
            }
        },
        mounted () {
            this.$nextTick(() => {
                document.addEventListener('wheel', (event) => {
                if (event.target.type === 'number') {
                    event.preventDefault();
                }
                }, { passive: false });
            });
            if (this.$store.state.isCustomer) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.anotherExpenses) {
                    this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.anotherExpenses;
                }
                this.cashFlowData = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.cashFlowData;
            }
            else if (this.$store.state.isSpouse) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.anotherExpenses) {
                    this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.anotherExpenses;
                }
                this.cashFlowData = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.cashFlowData;
            }
            else if (this.$store.state.isGuarantor) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.anotherExpenses) {
                    this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.anotherExpenses;
                }
                this.cashFlowData = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.cashFlowData;
            }
        }
    }
</script>
<style lang="scss">
// Estilos para poder centrar el título de el usuario
    .center-title {
        margin-top: 0;
        margin-bottom: 0;
    }
</style>
